import "./utilities_namespace.js";

(() => {
  let resetState;
  const eventName = "iframeReady";

  /*
   * Performs a persistent detection of when the iframe is loaded or reloaded and triggers the callback
   */
  Sparkle.Utilities.onIframeLoad = (iframeSelector, callback) => {
    // detectIframeReady can trigger on `interactive`, before the `load` event of the same document, so the callback
    // runs once per document.
    const iframe = resolveIframe(iframeSelector);
    let handledDocument = null;
    const callbackOncePerDocument = () => {
      const currentDocument = iframe.contentDocument;
      if (isIframeEmpty(iframe) || currentDocument === handledDocument) {
        return;
      }

      handledDocument = currentDocument;
      callback();
    };

    iframe.addEventListener("load", callbackOncePerDocument);

    return Sparkle.Utilities.detectIframeReady(iframeSelector, callbackOncePerDocument);
  };

  /*
   * Performs a one-time detection of when the iframe is ready and triggers the callback
   */
  Sparkle.Utilities.detectIframeReload = (iframeSelector, callback) => jQuery(iframeSelector).one("load", callback);

  /*
   * Performs a one-time detection of when the iframe initial load of an iframe's contents. This is more complicated than
   * the reload case because we want to ignore the state when the iframe has not been assigned any src, and is technically
   * "loaded". We poll the contents until it is present, then wait for it to be interactive.
   */
  Sparkle.Utilities.detectIframeReady = (iframeSelector, callback) => {
    const iframe = jQuery(iframeSelector)[0];
    if (!iframe) {
      throw new Error("iframe not found");
    }

    resetState(iframe);
    return waitForIframe(iframe)
      .then(() => triggerReadyEvent(iframe))
      .then(callback);
  };

  jQuery.event.special[eventName] = {
    add(handleObject) {
      if (isIframeReady(this)) {
        return handleObject.handler();
      }
    },
  };

  var triggerReadyEvent = (iframe) => iframe.dispatchEvent(new Event(eventName));

  var waitForIframe = (iframe) => {
    // The iframe is "ready" as soon as it is created so we need to wait until there is something in the body before
    // we start waiting for it to complete
    const deferred = new jQuery.Deferred();

    var interval = setInterval(() => {
      if (isIframeLoading(iframe)) {
        return;
      }
      if (isIframeEmpty(iframe)) {
        return;
      }

      clearInterval(interval);
      iframe.contentDocument.pageBuilderIframeLoadStatus = "waiting";
      return waitForDocument(iframe.contentDocument).then(() => deferred.resolve());
    }, 100); // How often to check if the iframe has started loading content

    return deferred.promise();
  };

  var waitForDocument = (doc) => waitForDocumentState(doc, "interactive", "complete");

  var waitForDocumentState = (doc, ...states) => {
    const deferred = new jQuery.Deferred();

    var callback = () => {
      if (states.includes(doc.readyState)) {
        doc.removeEventListener("readystatechange", callback);
        return deferred.resolve();
      }
    };

    doc.addEventListener("readystatechange", callback);
    callback(); // Check immediately in case we already missed the event

    return deferred.promise();
  };

  var resolveIframe = (iframeSelector) => {
    let iframe;
    if (iframeSelector instanceof Element) {
      iframe = iframeSelector;
    } else if (iframeSelector.jquery) {
      iframe = iframeSelector[0];
    } else {
      iframe = document.querySelector(iframeSelector);
    }
    if (!iframe) {
      throw new Error("iframe not found");
    }
    return iframe;
  };

  var isIframeLoading = (iframe) => !iframe.contentDocument || iframe.contentDocument.pageBuilderIframeLoadStatus;

  var isIframeReady = (iframe) =>
    iframe.contentDocument && iframe.contentDocument.pageBuilderIframeLoadStatus === "ready";

  var isIframeEmpty = (iframe) =>
    !iframe.contentDocument || !(iframe.contentDocument.body && iframe.contentDocument.body.children.length);

  return (resetState = (iframe) => {
    if (iframe.contentDocument) {
      return delete iframe.contentDocument.pageBuilderIframeLoadStatus;
    }
  });
})();
